module.exports = __webpack_public_path__ + "img/Battle5.c4d4efc8.jpg";